<template>
<v-footer absolute height="50px" dark class="nonvisible">
    <v-layout justify-end><a class="mr-7" href="/changelog">Lista wprowadzonych zmian/usprawnień (changelog).</a><span class="grey--text">Copyright © 2021 zamowienia.protektor.pl Wszelkie prawa zastrzeżone.</span></v-layout>
</v-footer>  
</template>

<script>
export default {

}
</script>

<style>

</style>